import { Button } from "../ui/button";
import { useLang } from "../../lib/LanguageContext";
import { BRAND } from "../../lib/brand";
import { REGISTER_URL } from "../../lib/config";
import { trackRegisterClick } from "../../lib/analytics";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  const { t } = useLang();

  return (
    <section className="py-20 sm:py-28 relative overflow-hidden" data-testid="final-cta-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="relative rounded-[32px] bg-ink text-white overflow-hidden p-10 sm:p-16 text-center">
          <div className="absolute -top-32 -left-32 w-80 h-80 rounded-full bg-brand-red/30 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-32 -right-32 w-80 h-80 rounded-full bg-brand-orange/25 blur-3xl pointer-events-none" />

          <img
            src={BRAND.mascot}
            alt=""
            className="hidden sm:block absolute top-6 right-8 w-24 h-24 rounded-2xl animate-float opacity-90"
            aria-hidden
          />

          <div className="relative max-w-3xl mx-auto">
            <h2 className="font-display font-extrabold text-3xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid="final-cta-title">
              {t.finalCta.title}
            </h2>
            <p className="mt-6 text-lg text-white/70 max-w-2xl mx-auto">{t.finalCta.subtitle}</p>
            <div className="mt-10">
              <a href={REGISTER_URL} rel="noopener" onClick={() => trackRegisterClick("final-cta")}>
                <Button
                  data-testid="final-cta-btn"
                  size="lg"
                  className="rounded-full bg-brand-red hover:bg-[#A60D25] text-white font-semibold px-8 h-14 text-base group"
                >
                  {t.finalCta.cta}
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
